import { faRefresh } from '@fortawesome/free-solid-svg-icons';

import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';

import { AuthService, NotificationService } from '@core/services';

import { ResetConfirmData } from '@shared/types';
import { equalPasswords, passwordStrengthValidator } from '@shared/validators';

import { environment } from '@env';

const TOKEN_ARRAY_LENGTH = 2;

@Component({
    selector: 'app-password-reset-confirm',
    templateUrl: './password-reset-confirm.component.html',
    styleUrls: ['./password-reset-confirm.component.scss'],
    standalone: false,
})
export class PasswordResetConfirmComponent implements OnInit {
    uid?: string;
    token?: string;
    email?: string;
    busy = false;
    success = false;
    public resetConfirmForm = new FormGroup(
        {
            email: new FormControl({ value: '', disabled: true }, [Validators.required, Validators.email]),
            newPassword1: new FormControl('', [
                Validators.required,
                Validators.minLength(environment.minPasswordLength),
                passwordStrengthValidator(),
            ]),
            newPassword2: new FormControl('', [Validators.required]),
        },
        {
            validators: [equalPasswords('newPassword1', 'newPassword2')],
        },
    );

    public loadingIcon = faRefresh;
    private errorMessage = $localize`:@@resetPassword.requestError:Het aanvragen van een nieuw wachtwoord is momenteel niet mogelijk. Probeer later opnieuw.`;
    minPasswordLength = environment.minPasswordLength;
    specialCharacters = environment.passwordSpecialCharacters;

    constructor(private route: ActivatedRoute, private authService: AuthService, private notificationService: NotificationService) {}

    ngOnInit(): void {
        this.uid = this.route.snapshot.params.id;
        const tokenArray = this.route.snapshot.params.token.split('_');

        if ((tokenArray ?? []).length !== TOKEN_ARRAY_LENGTH || this.uid === undefined) {
            this.notificationService.errorMessage(this.errorMessage);
            console.error('Token and/or email b64 invalid.');
            return;
        }

        this.token = tokenArray[0];
        this.email = window.atob(tokenArray[1]);
        this.resetConfirmForm.patchValue({
            email: this.email,
        });
    }

    onSubmit() {
        if (this.token === undefined || this.uid === undefined) {
            this.notificationService.errorMessage(this.errorMessage);
            return;
        }
        this.busy = true;
        this.success = false;
        this.resetConfirmForm.markAllAsTouched();
        let data = this.resetConfirmForm.value as ResetConfirmData;
        data.uid = this.uid;
        data.token = this.token;

        this.authService.resetPassword(data).subscribe({
            next: () => {
                this.busy = false;
                this.success = true;
                this.resetConfirmForm.reset();
            },
            error: (err) => {
                console.error(err);
                this.notificationService.errorMessage(this.errorMessage);
            },
        });
    }
}
